import { render, staticRenderFns } from "./TituloFuncionarios.vue?vue&type=template&id=94e216ea&"
import script from "./TituloFuncionarios.vue?vue&type=script&lang=js&"
export * from "./TituloFuncionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports